import axios from "axios";
import { EQM_TAG_SEPARATOR } from "../constants/eqmTags";

const BASE_HATTRICK_URL = import.meta.env.VITE_HATTRICK_URL;
const BALLPARK_BACKEND_BASE_URL = import.meta.env.VITE_BALLPARK_API_URL;

export const testAssetGeneration = (file, user) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/assetGeneration/test",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const runAssetGeneration = (file, user) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/assetGeneration/run",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const testMockupGeneration = (file, user) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/mockupGeneration/test",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const runMockupGeneration = (file, user) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/mockupGeneration/run",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const getEquipmentManagerConfig = (user) => {
  return axios.get(BASE_HATTRICK_URL + "equipmentManager/config", {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.stsTokenManager.accessToken,
    },
  });
};

export const insertEquipmentManagerConfig = (user, payload) => {
  console.log(payload);
  return axios.post(BASE_HATTRICK_URL + "equipmentManager/config", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.stsTokenManager.accessToken,
    },
  });
}

export const updateEquipmentManagerConfig = (user, payload) => {
  return axios.put(BASE_HATTRICK_URL + "equipmentManager/config", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.stsTokenManager.accessToken,
    },
  });
}

export const runAllFrontAssetGeneration = (payload, user) => {
  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/front/assetGeneration/runAll",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const runAllBackAssetGeneration = (payload, user) => {
  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/back/assetGeneration/runAll",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const stopFrontAssetGeneration = (user) => {
  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/front/assetGeneration/stop",
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const stopBackAssetGeneration = (user) => {
  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/back/assetGeneration/stop",
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const runAllMockupGeneration = (payload, user) => {
  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/mockupGeneration/runAll",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const stopMockupGeneration = (user) => {
  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/mockupGeneration/stop",
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const getEquipmentManagerStatus = (user) => {
  return axios.get(BASE_HATTRICK_URL + "equipmentManager/status", {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.stsTokenManager.accessToken,
    },
  });
};

export const testGraphicGeneration = (file, user) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/socialGraphicsGeneration/test",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const runGraphicGeneration = (file, user) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/socialGraphicsGeneration/run",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const getRunnableFrontAssets = (user) => {
  return axios.get(BASE_HATTRICK_URL + "equipmentManager/runnableFrontAssets", {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.stsTokenManager.accessToken,
    },
  });
}

export const getRunnableBackAssets = (user) => {
  return axios.get(BASE_HATTRICK_URL + "equipmentManager/runnableAssets", {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.stsTokenManager.accessToken,
    },
  });
}

export const getRunnableMockups = (user) => {
  return axios.get(BASE_HATTRICK_URL + "equipmentManager/runnableMockups", {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.stsTokenManager.accessToken,
    },
  });
}



export const updateVerified = (user, payload) => {
  return axios.put(
    BASE_HATTRICK_URL + "equipmentManager/verifyConfig",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const getNonVerifiedGraphics = (user) => {
  return axios.get(
    BASE_HATTRICK_URL + "equipmentManager/mediaDay/nonVerifiedGraphics",
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const postGraphicVerification = (user, payload) => {
  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/mediaDay/verifyGraphics",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const getSMGErrors = (user) => {
  return axios.get(
    BASE_HATTRICK_URL + "equipmentManager/mediaDay/mediaDayErrors",
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const uploadGeneralEQMAssetByFile = async (user, file, name, tags_list, asset_type, university) => {

  try {

    var tags = tags_list.join(EQM_TAG_SEPARATOR)
    if (university) {
      tags = university + EQM_TAG_SEPARATOR + tags
    } else {
      tags = "ALL" + EQM_TAG_SEPARATOR + tags
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", name);
    formData.append("tag", tags);
    formData.append("asset_type", asset_type);

    console.log(formData);
    const response = await axios.post(BASE_HATTRICK_URL + "equipmentManager/assets/general/upload/file",
      formData,
      {
        headers: {
          Authorization: "Bearer " + user.stsTokenManager.accessToken,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Failed to upload asset:", err);
    throw err;
  }
};

export const uploadGeneralEQMAssetByURL = async (user, url, name, tags_list, asset_type, university) => {

  try {

    var tags = tags_list.join(EQM_TAG_SEPARATOR)
    if (university) {
      tags = university + EQM_TAG_SEPARATOR + tags
    }else{
      tags = "ALL" + EQM_TAG_SEPARATOR + tags
    }


    const payload = {
      "url": url,
      "name": name,
      "tag": tags,
      "asset_type": asset_type
    }

    console.log(payload);

    const response = await axios.post(BASE_HATTRICK_URL + "equipmentManager/assets/general/upload/url",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.stsTokenManager.accessToken,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Failed to upload asset:", err);
    throw err;
  }
};

export const getGeneralEQMAssets = (user, axiosOptions, page, size, order, search, filter) => {
  return axios.get(
    BASE_HATTRICK_URL + `equipmentManager/assets/general?page=${page}&size=${size}&search=${btoa(search ? search : "")}`,
    {
      ...axiosOptions,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const getGeneralEQMAssetsByType = (user) => {
  return axios.get(
    BASE_HATTRICK_URL + "equipmentManager/assets/generalByType",
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};

export const getGeneralEQMAssetsByTypeForSku = (user, university, sku_type, options = {}) => {

  const payload = {
    "university": university,
    "sku_type": sku_type,
    // Server-side version of the client's EQM_TAG_VERSION_1_SUFFIX filter for
    // Jersey Art / Composite Font: cuts the response from 10-112MB to ~1-3MB.
    // include_ids keeps existing config values resolvable to a name/URL.
    "versioned_only": !!options.versionedOnly,
    "include_ids": options.includeIds || []
  }

  return axios.post(
    BASE_HATTRICK_URL + "equipmentManager/assets/generalByTypeForSku",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
      },
    }
  );
};
